import { render, staticRenderFns } from "./VisitorDetails.vue?vue&type=template&id=53bd9e41&"
import script from "./VisitorDetails.vue?vue&type=script&lang=js&"
export * from "./VisitorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports